export default "__VITE_ASSET__DIgLBLzv__"